import { Contact, ContactType } from './models';

export class ContactInfo {
	public static readonly contactList: Contact[] = [
		{
			type: ContactType.Phone,
			icon: 'pi pi-phone',
			customIcon: 'phone-call',
			label: 'header.contact.telephone1',
			value: '+381114144284',
			link: 'tel:+381114144284',
		},
		{
			type: ContactType.Phone,
			icon: 'pi pi-phone',
			customIcon: 'phone-call',
			label: 'header.contact.telephone2',
			value: '+381114144294',
			link: 'tel:+381114144294',
		},
		{
			type: ContactType.Phone,
			icon: 'pi pi-phone',
			customIcon: 'phone-call',
			label: 'header.contact.telephone3',
			value: '+381114144285',
			link: 'tel:+381114144285',
		},
		{
			type: ContactType.WhatsApp,
			icon: 'icon-whatsapp',
			customIcon: 'icon-whatsapp',
			label: 'header.contact.whatsApp',
			value: '+38162212282',
			link: 'https://wa.me/38162212282',
		},
		{
			type: ContactType.Viber,
			icon: '',
			customIcon: 'icon-viber',
			label: 'header.contact.viber',
			value: '+38162212282',
			link: 'viber://chat?number=%2B38162212282',
		},
		{
			type: ContactType.Email,
			icon: 'pi pi-envelope',
			customIcon: 'email-icon',
			label: 'header.contact.email',
			value: 'office@wayout.rs',
			link: 'mailto:office@wayout.rs',
		},
	];
}
